/* eslint-disable react/require-default-props */
import React, { ButtonHTMLAttributes } from 'react';

import { Container } from './styles';

export const ButtonClear: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  ...rest
}) => {
  return <Container {...rest}>{children}</Container>;
};
